import Action  from './baseActions';
import {
  ApiParams,
  Report,
} from '../../models';

// Types
interface ReportParams extends ApiParams {
  reload?: boolean;
}

export enum ReportActionTypes {
  LOAD_REPORTS = 'report/load_reports',
  LOADING_REPORTS = 'report/loading_reports',
  LOADED_REPORTS = 'report/loaded_reports',
  LOADING_REPORTS_FAILED = 'report/loading_reports_failed',
  UNSET_REPORTS = 'report/unset_reports',

  CREATE_REPORT = 'report/create_report',
  CREATING_REPORT = 'report/creating_report',
  CREATED_REPORT = 'report/created_report',
  CREATING_REPORT_FAILED = 'report/creating_report_failed',

  DELETE_REPORT = 'report/delete_report',
  DELETING_REPORT = 'report/deleting_report',
  DELETED_REPORT = 'report/deleted_report',
  DELETING_REPORT_FAILED = 'report/deleting_report_failed',

  DUPLICATE_REPORT = 'report/duplicate_report',
  DUPLICATING_REPORT = 'report/duplicating_report',
  DUPLICATED_REPORT = 'report/duplicated_report',
  DUPLICATING_REPORT_FAILED = 'report/duplicating_report_failed',

  TOGGLE_SELECT_REPORT = 'report/toggle_select_report',
  TOGGLE_SELECT_ALL_REPORTS = 'report/toggle_select_all_reports',

  BULK_ACTION = 'report/bulk_action',
  BULK_ACTION_SUCCESS = 'report/bulk_action_success',
  BULK_ACTION_FAILED = 'report/bulk_action_failed',

  /*
   * Bulk actions for reports.
   */
  UPDATE_REPORTS = 'report/update_reports',
  UPDATING_REPORTS = 'report/updating_reports',
  UPDATED_REPORTS = 'report/updated_reports',
  UPDATING_REPORTS_FAILED = 'report/updating_reports_failed',
}

// Interfaces

export interface LoadReportsAction extends Action {
  type: ReportActionTypes.LOAD_REPORTS;
  payload: ReportParams;
}

export interface LoadingReportsAction extends Action {
  type: ReportActionTypes.LOADING_REPORTS;
}

export interface LoadedReportsAction extends Action {
  type: ReportActionTypes.LOADED_REPORTS;
  payload: any;
}

export interface LoadingReportsFailedAction extends Action {
  type: ReportActionTypes.LOADING_REPORTS_FAILED;
}

export interface UnsetReportsAction extends Action {
  type: ReportActionTypes.UNSET_REPORTS;
}

export interface CreateReportAction extends Action {
  type: ReportActionTypes.CREATE_REPORT;
  payload: Partial<Report>;
}

export interface CreatingReportAction extends Action {
  type: ReportActionTypes.CREATING_REPORT;
}

export interface CreatedReportAction extends Action {
  type: ReportActionTypes.CREATED_REPORT;
  payload: any;
}

export interface CreatingReportFailedAction extends Action {
  type: ReportActionTypes.CREATING_REPORT_FAILED;
}

export interface DeleteReportAction extends Action {
  type: ReportActionTypes.DELETE_REPORT;
  payload: string;
}

export interface DeletingReportAction extends Action {
  type: ReportActionTypes.DELETING_REPORT;
}

export interface DeletedReportAction extends Action {
  type: ReportActionTypes.DELETED_REPORT;
  payload: string;
}

export interface DeletingReportFailedAction extends Action {
  type: ReportActionTypes.DELETING_REPORT_FAILED;
}

export interface DuplicateReportAction extends Action {
  type: ReportActionTypes.DUPLICATE_REPORT;
  payload: string;
}

export interface DuplicatingReportAction extends Action {
  type: ReportActionTypes.DUPLICATING_REPORT;
}

export interface DuplicatedReportAction extends Action {
  type: ReportActionTypes.DUPLICATED_REPORT;
  payload: string;
}

export interface DuplicatingReportFailedAction extends Action {
  type: ReportActionTypes.DUPLICATING_REPORT_FAILED;
}

export interface ToggleSelectReportAction extends Action {
  type: ReportActionTypes.TOGGLE_SELECT_REPORT;
  payload: {
    uid: string;
    selected: boolean;
  };
}

export interface ToggleSelectAllReportsAction extends Action {
  type: ReportActionTypes.TOGGLE_SELECT_ALL_REPORTS;
  payload: {
    selected: boolean;
  };
}

export interface BulkAction extends Action {
  type: ReportActionTypes.BULK_ACTION;
  payload: {
    action: string;
    selected: string[];
  };
}

export interface BulkActionSuccess extends Action {
  type: ReportActionTypes.BULK_ACTION_SUCCESS;
  payload: {
    action: string;
    selected: string[];
  };
}

export interface BulkActionFailed extends Action {
  type: ReportActionTypes.BULK_ACTION_FAILED;
}

export interface UpdateReportsAction extends Action {
  type: ReportActionTypes.UPDATE_REPORTS;
  payload: {
    reports: Partial<Report>[];
  };
}

export interface UpdatingReportsAction extends Action {
  type: ReportActionTypes.UPDATING_REPORTS;
}

export interface UpdatedReportsAction extends Action {
  type: ReportActionTypes.UPDATED_REPORTS;
  payload: any[];
}

export interface UpdatingReportsFailedAction extends Action {
  type: ReportActionTypes.UPDATING_REPORTS_FAILED;
}

// Functions

export function loadReports(properties: ReportParams): LoadReportsAction {
  return {
    type: ReportActionTypes.LOAD_REPORTS,
    payload: properties,
  };
}

export function loadingReports(): LoadingReportsAction {
  return {
    type: ReportActionTypes.LOADING_REPORTS,
  };
}

export function loadedReports(result: any, reload: boolean = false, page_size: number = 0): LoadedReportsAction {
  return {
    type: ReportActionTypes.LOADED_REPORTS,
    payload: {
      result,
      reload,
      page_size,
    },
  };
}

export function loadingReportsFailed(): LoadingReportsFailedAction {
  return {
    type: ReportActionTypes.LOADING_REPORTS_FAILED,
  }
}

export function unsetReports(): UnsetReportsAction {
  return {
    type: ReportActionTypes.UNSET_REPORTS,
  };
}

export function createReport(report: Partial<Report>): CreateReportAction {
  return {
    type: ReportActionTypes.CREATE_REPORT,
    payload: report,
  };
}

export function creatingReport(): CreatingReportAction {
  return {
    type: ReportActionTypes.CREATING_REPORT,
  };
}

export function createdReport(report: any): CreatedReportAction {
  return {
    type: ReportActionTypes.CREATED_REPORT,
    payload: report,
  };
}

export function creatingReportFailed(): CreatingReportFailedAction {
  return {
    type: ReportActionTypes.CREATING_REPORT_FAILED,
  };
}

export function deleteReport(uid: string): DeleteReportAction {
  return {
    type: ReportActionTypes.DELETE_REPORT,
    payload: uid,
  };
}

export function deletingReport(): DeletingReportAction {
  return {
    type: ReportActionTypes.DELETING_REPORT,
  };
}

export function deletedReport(uid: string): DeletedReportAction {
  return {
    type: ReportActionTypes.DELETED_REPORT,
    payload: uid,
  };
}

export function deletingReportFailed(): DeletingReportFailedAction {
  return {
    type: ReportActionTypes.DELETING_REPORT_FAILED,
  };
}

export function duplicateReport(uid: string): DuplicateReportAction {
  return {
    type: ReportActionTypes.DUPLICATE_REPORT,
    payload: uid,
  };
}

export function duplicatingReport(): DuplicatingReportAction {
  return {
    type: ReportActionTypes.DUPLICATING_REPORT,
  };
}

export function duplicatedReport(report: any): DuplicatedReportAction {
  return {
    type: ReportActionTypes.DUPLICATED_REPORT,
    payload: report,
  };
}

export function duplicatingReportFailed(): DuplicatingReportFailedAction {
  return {
    type: ReportActionTypes.DUPLICATING_REPORT_FAILED,
  };
}

export function toggleSelectReport(uid: string, selected: boolean): ToggleSelectReportAction {
  return {
    type: ReportActionTypes.TOGGLE_SELECT_REPORT,
    payload: {
      uid,
      selected,
    }
  };
}

export function toggleSelectAllReports(selected: boolean): ToggleSelectAllReportsAction {
  return {
    type: ReportActionTypes.TOGGLE_SELECT_ALL_REPORTS,
    payload: {
      selected,
    }
  };
}

export function bulkAction(action: string, selected: string[]): BulkAction {
  return {
    type: ReportActionTypes.BULK_ACTION,
    payload: {
      action,
      selected,
    }
  };
}

export function bulkActionSuccess(action: string, selected: string[]): BulkActionSuccess {
  return {
    type: ReportActionTypes.BULK_ACTION_SUCCESS,
    payload: {
      action,
      selected,
    }
  };
}

export function updateReports(reports: Partial<Report>[]): UpdateReportsAction {
  return {
    type: ReportActionTypes.UPDATE_REPORTS,
    payload: {
      reports,
    }
  };
}

export function updatingReports(): UpdatingReportsAction {
  return {
    type: ReportActionTypes.UPDATING_REPORTS,
  };
}

export function updatedReports(result: any[]): UpdatedReportsAction {
  return {
    type: ReportActionTypes.UPDATED_REPORTS,
    payload: result,
  };
}

export function updatingReportsFailed(): UpdatingReportsFailedAction {
  return {
    type: ReportActionTypes.UPDATING_REPORTS_FAILED,
  };
}

// Types

export type ReportActions =
  | LoadReportsAction
  | LoadingReportsAction
  | LoadedReportsAction
  | LoadingReportsFailedAction
  | UnsetReportsAction
  | CreateReportAction
  | CreatingReportAction
  | CreatedReportAction
  | CreatingReportFailedAction
  | DeleteReportAction
  | DeletingReportAction
  | DeletedReportAction
  | DeletingReportFailedAction
  | DuplicateReportAction
  | DuplicatingReportAction
  | DuplicatedReportAction
  | DuplicatingReportFailedAction
  | ToggleSelectReportAction
  | ToggleSelectAllReportsAction
  | BulkAction
  | BulkActionSuccess
  | BulkActionFailed
  | UpdateReportsAction
  | UpdatingReportsAction
  | UpdatedReportsAction
  | UpdatingReportsFailedAction;
